"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.RequestRouter = void 0;
var types_1 = require("./types");
var getErrorFromCatch_1 = require("../packages/unknown-error/getErrorFromCatch");
var Either_1 = require("fp-ts/Either");
var lodash_1 = require("lodash");
var promiseTimeout_1 = require("../packages/promise-utils/promiseTimeout");
/**
 * Takes incomming requests and routes them to the correct handler
 *
 * TODO: deal with the version field on requests
 */
var RequestRouter = /** @class */ (function () {
    function RequestRouter(handlers) {
        this.handlers = (0, lodash_1.keyBy)(handlers, 'name');
    }
    RequestRouter.prototype.getResponseForRequest = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var handler, decodedArgs, response, err_1, encodedResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        handler = this.handlers[msg.name];
                        if (!handler) {
                            return [2 /*return*/, { code: types_1.ResponseCode.UNKNOWN_METHOD_NAME, name: msg.name }];
                        }
                        decodedArgs = handler.codecs.req.decode(msg.payload);
                        if ((0, Either_1.isLeft)(decodedArgs)) {
                            return [2 /*return*/, { code: types_1.ResponseCode.ARG_DECODE_ERROR, err: decodedArgs.left }];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, promiseTimeout_1.promiseTimeout)(handler.process(decodedArgs.right), handler.timeout)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [2 /*return*/, {
                                code: types_1.ResponseCode.HANDLER_RUNTIME_ERROR,
                                err: (0, getErrorFromCatch_1.getErrorFromCatch)(err_1)
                            }];
                    case 4:
                        encodedResult = handler.codecs.res.encode(response);
                        if ((0, Either_1.isLeft)(encodedResult)) {
                            return [2 /*return*/, {
                                    code: types_1.ResponseCode.RESULT_ENCODE_ERROR,
                                    err: encodedResult.left
                                }];
                        }
                        return [2 /*return*/, { code: types_1.ResponseCode.OK, response: encodedResult.right }];
                }
            });
        });
    };
    return RequestRouter;
}());
exports.RequestRouter = RequestRouter;
//# sourceMappingURL=RequestRouter.js.map